export * from './delete-tour-status.component';
export * from './delete-tour-status.component.module';